// converts military time to AM/PM
export const convertToAmPmHours = (hours) => {
    const amPm = hours >= 12 ? 'pm' : 'am';
    const hoursAmPm = hours % 12;
    return {
        amPm,
        hours: hoursAmPm ? hoursAmPm : 12,
    };
};
const addLeadingZero = (timeUnit) => {
    return `0${timeUnit}`.slice(-2);
};
export const getFormattedTime = (hours = 0, minutes = 0, locale, leadingHourZero) => {
    const amPmHours = convertToAmPmHours(hours);
    const localeHours = locale === 'en_US' ? amPmHours.hours : hours;
    const formattedHours = leadingHourZero ? addLeadingZero(localeHours) : localeHours;
    const formattedMinutes = addLeadingZero(minutes);
    const formmatedTime = `${formattedHours}:${formattedMinutes}`;
    const amPmResult = locale === 'en_US' ? amPmHours.amPm : '';
    return {
        time: formmatedTime,
        fullTime: `${formmatedTime}${amPmResult}`,
        amPm: amPmResult,
        minutes: formattedMinutes,
    };
};
